/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import i18n functions */
import { useI18n } from '@/context/I18nContext';

/* Import types */
import type { OverviewStatusCounts } from '@/lib/overview/overviewCards';

interface OverviewCardSummaryProps {
    sensorCount: number;
    statusCounts: OverviewStatusCounts;
}

function OverviewCardSummary({
    sensorCount,
    statusCounts,
}: OverviewCardSummaryProps) {
    const { t } = useI18n();
    const sensorCountLabel = sensorCount === 1
        ? t('{count} sensor', { count: sensorCount })
        : t('{count} sensors', { count: sensorCount });

    return (
        <div className="mt-1 flex flex-wrap items-center justify-between gap-2 text-sm leading-relaxed text-base-content/65">
            <span>{sensorCountLabel}</span>
            <div className="flex flex-wrap justify-end gap-1">
                {statusCounts.danger > 0 ? (
                    <span className="badge badge-error badge-sm">
                        {t('Error')}: {statusCounts.danger}
                    </span>
                ) : null}
                {statusCounts.warning > 0 ? (
                    <span className="badge badge-warning badge-sm">
                        {t('Warning')}: {statusCounts.warning}
                    </span>
                ) : null}
                {statusCounts.success > 0 ? (
                    <span className="badge badge-success badge-sm">
                        {t('OK')}: {statusCounts.success}
                    </span>
                ) : null}
            </div>
        </div>
    );
}

export default OverviewCardSummary;
